module.exports = __webpack_public_path__ + "static/media/buy_pause_payment_5.ef217a74.jpg";